// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FunnelPlotTwoToneSvg from "@fishx/icons-svg/es/asn/FunnelPlotTwoTone";
import FishxIcon from '../components/FishxIcon';

var FunnelPlotTwoTone = function FunnelPlotTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FunnelPlotTwoToneSvg
  }));
};

FunnelPlotTwoTone.displayName = 'FunnelPlotTwoTone';
export default React.forwardRef(FunnelPlotTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FunnelPlotTwoTone.js
// module id = 2855
// module chunks = 0